import { Box, Stack } from '@mui/material';
import { useState } from 'react';
import { useCosInfo } from '@/controllers/gridManager/accountsManager/accountManager';
import classNames from 'classnames/bind';
import styles from './Step1.scss';
import TransAuthInput from '@/views/components/componentsUI/TransAuthInput';
import ButtonElement from '@/views/elements/button/ButtonElement';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
import { useTheme } from '@mui/system';
import { useTranslation } from 'react-i18next';
import ViewNumberFormat from '@/views/elements/Inputs/ViewNumberFormat';
import { submitDeleteAccountMaster } from '@/controllers/gridManager/masterTransManager/masterTransManager';
const cx = classNames.bind(styles);

export type PropsStep = {
  close: () => void,
  next: () => void,
  data: any
}

export type RadioStopCopy = "TRANS" | "SELL"
const Step1 = ({ close, next, data }: PropsStep) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { cosInfo } = useCosInfo()
  const { refaccount } = cosInfo
  const [authInput, setAuthInput] = useState({
    tokenid: '',
    transactionId: '',
    authtype: '',
    code: '',
    isSaveVerify: false
  });

  const handleNext = async () => {
    setStateLoadingAction(true)
    const response = await submitDeleteAccountMaster(refaccount, authInput)
    if (response.isSuccess) {
      next()
    }
    setStateLoadingAction(false)
  }

  const handleAuthInputChange = (input: any) => {
    setAuthInput(input)
  }

  return (
    <Box className="Step1" sx={{ height: "auto", overflow: "auto" }}>
      <Stack direction={"column"} spacing='20px'>
        <TypographyElement
          ColorElement="secondary"
          FontWeightElement={400}
          FontSizeElement="16px"
          lineHeight='21px'
        >
          {t('copytrade.deleteMasterAccount.balanceRemain')}
        </TypographyElement>

        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          p="20px"
          borderRadius="10px"
          gap="15px"
          bgcolor={theme.palette.background.badge}
        >
          <Stack direction={"row"} justifyContent='space-between'>
            <TypographyElement
            ColorElement='secondary'
            FontWeightElement={400}
            FontSizeElement='14px'
            sx={{ lineHeight: "21px" }}
            >
            {t('copytrade.deleteMasterAccount.eMasterTrader')}
            </TypographyElement>
            <TypographyElement ColorElement='primary'>{data?.fullname}</TypographyElement>
          </Stack>
          <Stack direction={"row"} justifyContent='space-between'>
            <TypographyElement
            ColorElement='secondary'
            FontWeightElement={400}
            FontSizeElement='14px'
            sx={{ lineHeight: "21px" }}
            >
            {t('copytrade.deleteMasterAccount.copierNumber')}
            </TypographyElement>
            <TypographyElement ColorElement='primary'>{data?.copier_number}</TypographyElement>
          </Stack>
          <Stack direction={"row"} justifyContent='space-between'>
            <TypographyElement
            ColorElement='secondary'
            FontWeightElement={400}
            FontSizeElement='14px'
            sx={{ lineHeight: "21px" }}
            >
            {t('copytrade.deleteMasterAccount.availableBalance')}
            </TypographyElement>
            <TypographyElement ColorElement='primary'><ViewNumberFormat displayType='text' value={data?.avlbalance}></ViewNumberFormat></TypographyElement>
          </Stack>
          <Stack direction={"row"} justifyContent='space-between'>
            <TypographyElement
            ColorElement='secondary'
            FontWeightElement={400}
            FontSizeElement='14px'
            sx={{ lineHeight: "21px" }}
            >
            {t('copytrade.deleteMasterAccount.instrumentValue')}
            </TypographyElement>
            <TypographyElement ColorElement='primary'><ViewNumberFormat displayType='text' value={data?.sec_price}></ViewNumberFormat></TypographyElement>
          </Stack>
          <Stack direction={"row"} justifyContent='space-between'>
            <TypographyElement
            ColorElement='secondary'
            FontWeightElement={400}
            FontSizeElement='14px'
            sx={{ lineHeight: "21px" }}
            >
            {t('copytrade.deleteMasterAccount.dividendsReturning')}
            </TypographyElement>
            <TypographyElement ColorElement='primary'><ViewNumberFormat displayType='text' value={data?.careceiving}></ViewNumberFormat></TypographyElement>
          </Stack>
          <Stack direction={"row"} justifyContent='space-between'>
            <TypographyElement
            ColorElement='secondary'
            FontWeightElement={400}
            FontSizeElement='14px'
            sx={{ lineHeight: "21px" }}
            >
              {t('copytrade.deleteMasterAccount.debt')}
            </TypographyElement>
            <TypographyElement ColorElement='primary'><ViewNumberFormat displayType='text' value={data?.debt}></ViewNumberFormat></TypographyElement>
          </Stack>
        </Stack>

        <Box>
          <TransAuthInput
            onChange={handleAuthInputChange}
          />
        </Box>

        <Stack direction={"row"} spacing='10px' justifyContent={"center"}>
          <ButtonElement
            className={cx("btn-register")}
            variant="contained"
            onClick={() => close()}
            customType='Secondary'
            sx={{
              fontSize: '14px',
              lineHeight: '21px',
              fontWeight: 500
            }}
          >
            {t('copytrade.common.close')}
          </ButtonElement>
          <ButtonElement
            className={cx("btn-register")}
            variant="contained"
            onClick={() => handleNext()}
            sx={{
              fontSize: '14px',
              lineHeight: '21px',
              fontWeight: 500
            }}
          >
            {t('copytrade.common.next')}
          </ButtonElement>
        </Stack>
      </Stack>
    </Box>
  );
}

export default Step1